import styled from 'styled-components';
import { HEADER_CONTAINER } from '../../../styles/Layout';
import { FONT_STACK } from '../../../styles/constants';

export const Container = styled.div`
  ${HEADER_CONTAINER}
  ${FONT_STACK}
`;

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
